import { IVisaPrepForm } from '../../../types';
export type IVisaPrepFormState = IVisaPrepForm

export enum VisaPrepFormActionTypes {
  UPDATE_VPI_FIELD = '@@visa/visaPersonalInfo/UPDATE_PI_FIELD'
}

export enum Pages {
  PAGE1 = 'student-v-step1',
  PAGE1_2 = 'student-v-step1-part2',
  PAGE2_1 = 'student-v-step2-part1',
  PAGE2_2 = 'student-v-step2-part2',
  PAGE2_3 = 'student-v-step2-part3',
  PAGE2_4 = 'student-v-step2-part4',
  PAGE2_5 = 'student-v-step2-part5',
  PAGE2_6 = 'student-v-step2-part6',
  PAGE2_7 = 'student-v-step2-part7',
  PAGE2_8 = 'student-v-step2-part8',
  PAGE3_1 = 'student-v-step3-part1',
  PAGE3_2 = 'student-v-step3-part2',
  PAGE3_3 = 'student-v-step3-part3',
  PAGE3_4 = 'student-v-step3-part4',
  PAGE3_5 = 'student-v-step3-part5',
  PAGE4 = 'student-v-step4',
  PAGE5 = 'student-v-step5',
  PAGE6 = 'student-v-step6',
  PAGE7_1 = 'student-v-step7-part1',
  PAGE7_2 = 'student-v-step7-part2',
  PAGE7_3 = 'student-v-step7-part3',
  PAGE8 = 'student-v-step8'
}
